import DashboardLoadingDataView from '../../components/DashboardLoadingDataView'
import DashboardLayout from '../../components/DashboardLayout'
import { Box } from '@mui/material'
import { enqueueSnackbar, SnackbarProvider } from 'notistack'
import useUserPage from './useUserPage'
import Log from './Log'
import OrdersTable from './OrdersTable'
import SessionsTable from './SessionsTable'
import SettingsAndLimits from './SettingsAndLimits'
import FreeRecording from './FreeRecording'
import EditUserModal from '../components/EditUserModal'
import UserHeader from './UserHeader'

export default function UserDeepDivePage() {
    const {
        loading,
        user,
        openEdit,
        settingDate,
        loadingSettings,
        sessionsData,
        ordersData,
        setOpenEdit,
        setNewOrg,
        setNewRole,
        setSettingDate,
        onEditUserSubmit,
        onDelete,
        getUserSettings,
    } = useUserPage()

    if (loading) return <DashboardLoadingDataView loading={loading} />

    return (
        <DashboardLayout>
            {user && (
                <UserHeader
                    user={user}
                    onEdit={() => setOpenEdit(true)}
                    onDelete={onDelete}
                />
            )}
            {user && (
                <>
                    <Box sx={{ mb: 2 }}>
                        <Log
                            accountProfile={user.accountProfile}
                            adminProfile={user.adminProfile}
                        />
                    </Box>

                    <Box sx={{ mb: 2 }}>
                        <OrdersTable dataSource={ordersData} />
                    </Box>

                    <Box sx={{ mb: 2 }}>
                        <SessionsTable
                            enqueueSnackbar={enqueueSnackbar}
                            dataSource={sessionsData}
                        />
                    </Box>

                    <Box sx={{ mb: 2 }}>
                        <FreeRecording userId={user.accountProfile.id} />
                    </Box>

                    {user.adminProfile && (
                        <Box sx={{ mb: 2 }}>
                            <SettingsAndLimits
                                settingDate={settingDate}
                                loadingSettings={loadingSettings}
                                setSettingDate={setSettingDate}
                                getUserSettings={getUserSettings}
                                settings={user.settings}
                            />
                        </Box>
                    )}

                    <EditUserModal
                        open={openEdit}
                        setOpen={setOpenEdit}
                        setNewOrg={setNewOrg}
                        user={user}
                        submit={onEditUserSubmit}
                        setNewRole={setNewRole}
                    />
                    <SnackbarProvider
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                    />
                </>
            )}
        </DashboardLayout>
    )
}
